export const bankPaymentEntryRowStyle = {
  bookingText: {
    paddingRight: 10,
  },
  link: {
    color: "#137f7b",
    textDecoration: "none",
  },
  searchContainer: {
    width: 500,
    height: 500,
  },
};
